export const ACCORDION_ANIMATION_DURATION = 600;
